export const PROFILE_UPLOAD_AVATAR = 'PROFILE_UPLOAD_AVATAR';

export const PROFILE_UPDATE_AVATAR_SUCCESS = 'PROFILE_UPDATE_AVATAR_SUCCESS';
export const PROFILE_UPDATE_AVATAR_ERROR = 'PROFILE_UPDATE_AVATAR_ERROR';

export const PROFILE_AVATAR_CLEAN_STATE = 'PROFILE_AVATAR_CLEAN_STATE';

export const PROFILE_REMOVE_AVATAR = 'PROFILE_REMOVE_AVATAR';